import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useAuth, USER_NAME_ROLE } from "../../app/auth";
import { useNavigate } from "react-router-dom";
import LoginApi from "./loginApi";
import CommonApi from "src/commonApi";

const LogoutPage = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!auth || !navigate) {
      return;
    }
    addLogoutAuthLog()
    auth.signOut();
    navigate('/login');
  }, [auth]);

  const addLogoutAuthLog = async () => {  
    LoginApi.addAuthLog({
      reason: '-',
      status: 'Success',  
      action: 'Logout',
      created_by: sessionStorage.getItem(USER_NAME_ROLE) == "admin"
        ? 1
        : 2,
    }).then(() => {
    }).catch((err) => {
      CommonApi.addAuditFailureLog({
        type: "Auth log",
        reason: err?.Message,
        created_by: sessionStorage.getItem(USER_NAME_ROLE) === "admin" ? 1 : 2,
      });
    })
  }
  return (
    <Box
      sx={{
        p: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box>
        <Typography>Session is logged out</Typography>
      </Box>
    </Box>
  );
};
export default LogoutPage;
